export type UpdateContactInfoViewType = 'email' | 'mobile' | null;

export type UpdateContactInfoState = {
    email?: string;
    mobile?: string;
};

export const updateContactInfoInitialState: UpdateContactInfoState = {
    email: undefined,
    mobile: undefined,
};
